import api from '@/utils/api'
import { buildListQuery } from '@/utils/listQuery'

export default {
    // the requests waiting for a decision (polled for the topbar notifications)
    getPendingPostponements() {
        return api.get(`postponements/pending`)
    },

    getFilteredPostponements(filter, page, size, sort) {
        return api.get(`postponements` + buildListQuery({ filter, page, size, sort }))
    },

    // postpones the match and notifies the followers of both teams
    approvePostponement(id) {
        return api.post(`postponements/${id}/approve`)
    },

    // gives the postponement back to the team
    rejectPostponement(id) {
        return api.post(`postponements/${id}/reject`)
    }
}
